import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	Renderer2
} from '@angular/core';
import {
	CommunicationEvents,
	SubscriptionPlan
} from '@models/subscription.model';

@Component({
	selector: 'subscription-card',
	template: require('./subscription-card.html'),
	styles: [require('./subscription-card.scss')]
})
export class SubscriptionCardComponent implements OnInit, OnDestroy {
	@Input() card: SubscriptionPlan;
	@Output() planSelect: EventEmitter<SubscriptionPlan> = new EventEmitter();

	private disableButton: boolean;
	private checkoutOpenEvent;
	private messageReceived;
	constructor(private renderer: Renderer2) {}

	ngOnInit(): void {
		this.onCheckoutModalOpenEvent();
		this.onMessageReceived();
	}

	ngOnDestroy(): void {
		this.checkoutOpenEvent();
		this.messageReceived();
	}

	selectPlan(): void {
		this.disableButton = true;
		this.planSelect.emit(this.card);
	}

	private onCheckoutModalOpenEvent(): void {
		this.checkoutOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.planCheckoutOpen,
			(): void => {
				this.disableButton = false;
			}
		);
	}
	private onMessageReceived(): void {
		this.messageReceived = this.renderer.listen(
			'document',
			CommunicationEvents.messageReceived,
			(): boolean => (this.disableButton = false)
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/subscription/modals/subscription-modal/subscription-card/subscription-card.ts